var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessory192(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 188,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-485 -13)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M559 54C559 73.8821 542.882 90.0001 523 90.0001 503.118 90.0001 487 73.8821 487 54 487 34.1178 503.118 17.9999 523 17.9999 542.882 17.9999 559 34.1178 559 54Z",
    fill: "#4289C1",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 144.5C650 174.6 625.6 199 595.5 199 565.4 199 541 174.6 541 144.5 541 114.4 565.4 90.0001 595.5 90.0001 625.6 90.0001 650 114.4 650 144.5Z",
    fill: "#4289C1",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 72C650 101.824 625.6 126 595.5 126 565.4 126 541 101.824 541 72 541 42.1765 565.4 17.9999 595.5 17.9999 625.6 17.9999 650 42.1765 650 72Z",
    fill: "#4289C1",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596 81.0001C596 105.853 575.629 126 550.5 126 525.371 126 505 105.853 505 81.0001 505 56.1472 525.371 36.0001 550.5 36.0001 575.629 36.0001 596 56.1472 596 81.0001Z",
    fill: "#4289C1",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614 126C614 145.882 597.658 162 577.5 162 557.341 162 541 145.882 541 126 541 106.118 557.341 90.0001 577.5 90.0001 597.658 90.0001 614 106.118 614 126Z",
    fill: "#4289C1",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessory192);
export default __webpack_public_path__ + "static/media/accessory19-2.440c177caba5953a1f6460083f6c80a2.svg";
export { ForwardRef as ReactComponent };